// areas
export const FOOD_AREAS = [
  "Овочі та фрукти",
  "Бакалія",
  "Напої",
  "Солодощі",
  "Дитяче харчування",
  "Консерви",
  "М'ясо та птиця",
  "Риба та морепродукти",
  "Молочне та яйця",
  "Заморожені / Напівфабрикати",
  "Випічка та хліб",
  "Інше",
];

// sections by area
const SECTIONS_BY_AREA = {
  "Овочі та фрукти": ["Фрукти", "Овочі", "Ягоди", "Зелень", "Гриби"],

  "Бакалія": [
    "Крупи / Бобові",
    "Борошно",
    "Олія",
    "Снеки / Солоні",
    "Соуси / Пасти",
    "Спеції / Приправи",
    "Сухофрукти / Горіхи",
  ],

  "Напої": [
    "Чай",
    "Кава",
    "Какао / Гарячий шоколад",
    "Безалкогольні напої",
  ],

  "Солодощі": [
    "Шоколад / Цукерки",
    "Печиво / Вафлі / Пряники",
    "Джем / Варення / Мед / Пасти",
    "Кекси / Бісквіти / Торти",
  ],

  "Дитяче харчування": [
    "Суміші",
    "Пюре",
    "Каші",
    "Соки / Напої",
    "Печиво / Снеки",
  ],

  "Консерви": [
    "Рибні",
    "Мʼясні / Паштети",
    "Овочеві",
    "Фруктові",
    "Інше",
  ],

  "М'ясо та птиця": [
    "Свинина",
    "Яловичина",
    "Птиця",
    "Інше мʼясо",
  ],

  "Риба та морепродукти": [
    "Риба",
    "Морепродукти",
  ],

  "Молочне та яйця": [
    "Молоко / Кефір / Сметана",
    "Сир / Творог",
    "Йогурти",
    "Масло / Спреди",
    "Яйця",
  ],

  "Заморожені / Напівфабрикати": [
    "Пельмені / Вареники",
    "Напівфабрикати мʼясні / рибні",
    "Овочеві суміші",
    "Випічка (заморожена)",
    "Інше",
  ],

  "Випічка та хліб": [
    "Хліб / Лаваш",
    "Булочки / Круасани",
    "Пироги / Піца",
    "Сухарі / Сушки",
  ],

  "Інше": ["Інші продукти"],
};

// subcategories
const SUBCATS_BY_SECTION = {
  "Фрукти": [],
  "Овочі": [],
  "Ягоди": [],
  "Зелень": [],
  "Гриби": [],

  "Крупи / Бобові": [],
  "Борошно": [],
  "Олія": [],
  "Снеки / Солоні": [],
  "Соуси / Пасти": [],
  "Спеції / Приправи": [],
  "Сухофрукти / Горіхи": [],

  "Чай": [],
  "Кава": [],
  "Какао / Гарячий шоколад": [],
  "Безалкогольні напої": [],

  "Шоколад / Цукерки": [],
  "Печиво / Вафлі / Пряники": [],
  "Джем / Варення / Мед / Пасти": [],
  "Кекси / Бісквіти / Торти": [],

  "Суміші": [],
  "Пюре": [],
  "Каші": [],
  "Соки / Напої": [],
  "Печиво / Снеки": [],

  "Рибні": [],
  "Мʼясні / Паштети": [],
  "Овочеві": [],
  "Фруктові": [],
  "Інше": [],

  "Свинина": [],
  "Яловичина": [],
  "Птиця": [],
  "Інше мʼясо": [],
  "Риба": [],
  "Морепродукти": [],
  "Молоко / Кефір / Сметана": [],
  "Сир / Творог": [],
  "Йогурти": [],
  "Масло / Спреди": [],
  "Яйця": [],

  "Пельмені / Вареники": [],
  "Напівфабрикати мʼясні / рибні": [],
  "Овочеві суміші": [],
  "Випічка (заморожена)": [],

  "Хліб / Лаваш": [],
  "Булочки / Круасани": [],
  "Пироги / Піца": [],
  "Сухарі / Сушки": [],

  "Інші продукти": [],
};

// fields
export const foodFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Сфера *",
      type: "select",
      options: FOOD_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
